
//card page

$(window).on('load', function() {
	$('[data-button="number"]').each(function(index, value) {
		$(this).val(0);
	})
})

$('[data-button="minus"]').on('click', function() {
	var input = $(this).siblings('[data-button="number"]');
	var inputVal = input.val();
	if (inputVal <= 0) {	
		$(this).css('color', '#dbe0e2');
		return false;
	} else if (inputVal > 0) {
		input.val(parseInt(inputVal) - 1);
		$(this).css('color', '#000');

		if(input.val() == 0) {
			$(this).css('color', '#dbe0e2');
		}
	}
})

$('[data-button="plus"]').on('click', function() {
	var input = $(this).siblings('[data-button="number"]');
	var inputVal = input.val();

	if (inputVal > 0) {
		input.val(parseInt(inputVal) + 1);
		$(this).siblings('[data-button="minus"]').css('color', '#000000');

	} else if (inputVal <= 0) {	
		$(this).siblings('[data-button="minus"]').css('color', '#dbe0e2');
		input.val(parseInt(inputVal) + 1);

		if(input.val() == 1) {
			$(this).siblings('[data-button="minus"]').css('color', '#000000');
		}
	}
})

$('.button__arrow-up').on('click', function(e) {
	e.preventDefault();
	$('html, body').animate({scrollTop: 0},500);
    return false;
})